import type { SiteModule } from './modules';

export function hasWeb(mod: SiteModule): boolean {
  return Boolean(mod.webUrl.trim());
}

export function hasApk(mod: SiteModule): boolean {
  return Boolean(mod.apkName.trim());
}

export function apkHref(apkName: string): string {
  return `/app/${encodeURIComponent(apkName.trim())}`;
}

export function iconClickHref(mod: SiteModule): string | null {
  if (hasWeb(mod)) return mod.webUrl.trim();
  if (hasApk(mod)) return apkHref(mod.apkName);
  return null;
}

export function iconGlyph(name: string): string {
  return [...name.trim()][0] ?? '';
}

const PALETTE = ['#2c5be8', '#1f7a4c', '#b45309', '#7c3aed', '#0f766e', '#be123c'];

export function accentFor(index: number): string {
  return PALETTE[index % PALETTE.length];
}
